var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabometInt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 60,
    viewBox: "0 0 160 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.923 31.153H116.873V28.5446H111.842V23.2483H115.857V20.64H112.051C111.89 20.64 111.842 20.5923 111.842 20.4332V15.5346H116.873V12.9262H108.923V31.153ZM129.984 12.9262H121.018V15.5346H124.049V31.153H126.936V15.5346H129.968V12.9262H129.984Z",
    fill: "#221E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0565 11.9402L83.8623 14.1033L88.3454 16.6639V26.8588L83.8623 29.4195L79.3791 31.9801L74.896 29.4195L70.4128 26.8588V16.6639L74.896 14.1033L79.3791 11.5426L80.0565 11.9243V11.9402ZM82.4915 16.4412L79.363 14.6599L76.2345 16.4412L73.1221 18.2226V25.3479L76.2345 27.1292L79.363 28.9105L82.4915 27.1292L85.6039 25.3479V18.2226L82.4915 16.4412Z",
    fill: "#31479D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9135 23.1211C65.3652 21.1648 63.3978 20.64 62.1561 20.64H60.0274V15.805H65.4297V12.9262H57.1407V31.153H62.1722C63.4139 31.153 64.3493 30.7235 65.1233 29.9601C65.5265 29.5625 65.72 29.2285 65.9135 28.6559C66.2844 27.5903 66.1554 24.0436 65.9135 23.1211ZM63.1882 27.1291C63.1882 28.0197 62.6721 28.5287 61.7529 28.5287H60.0435V23.2324H61.7368C62.398 23.2324 62.8656 23.3438 63.0753 24.1231C63.2849 24.9979 63.172 26.2702 63.172 27.1132L63.1882 27.1291Z",
    fill: "#221E1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0773 31.153H54.0284L51.0773 12.9262H46.5296L43.5785 31.153H46.5296L47.0295 27.9084H50.5935L51.0934 31.153H51.0773ZM47.3843 25.475L48.7551 16.473H48.868L50.2387 25.475H47.4005H47.3843Z",
    fill: "#221E1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.698 12.9262L98.6825 25.3955H98.5858L96.5539 12.9262H92.49V31.153H95.0702L95.0218 18.7155H95.1347L97.1667 31.153H100.086L102.134 18.7155H102.23L102.198 31.153H104.778V12.9262H100.698Z",
    fill: "#221E1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4988 12.9262H32.9511L30 31.153H32.9511L35.1766 16.473H35.2895L37.4988 31.153H40.4499L37.4988 12.9262Z",
    fill: "#221E1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 40.2186H31.2579V45.0218L34.9347 40.2186H36.1119V46.978H34.8541V42.1907L31.1772 46.978H30V40.2186Z",
    fill: "#808284"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4326 40.2186V46.978H46.1586V44.0834H42.6108V46.978H41.3368V40.2186H42.6108V43.0019H46.1586V40.2186H47.4326Z",
    fill: "#808284"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6729 41.2686H55.3991V46.9625H54.1412V41.2686H51.8835V40.203H57.6729V41.2686Z",
    fill: "#808284"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2037 45.9128V46.9625H62.0593V40.203H67.0585V41.2527H63.3333V43.0022H66.6392V44.036H63.3333V45.8968H67.2037V45.9128Z",
    fill: "#808284"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5409 41.2686H73.1382V46.9625H71.8965V40.203H76.5409V41.2686Z",
    fill: "#808284"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2331 40.5052C85.6685 40.696 86.0071 40.9823 86.249 41.3322C86.4909 41.698 86.6038 42.1274 86.6038 42.6205C86.6038 43.1135 86.4909 43.543 86.249 43.8929C86.0071 44.2428 85.6685 44.529 85.2331 44.7199C84.7976 44.9108 84.2816 45.0062 83.6849 45.0062H82.1368V46.9625H80.8628V40.203H83.6849C84.2816 40.203 84.7976 40.2984 85.2331 40.4893V40.5052ZM84.8944 43.6066C85.1847 43.368 85.3298 43.0499 85.3298 42.6046C85.3298 42.1593 85.1847 41.8412 84.8944 41.6026C84.6041 41.364 84.1848 41.2527 83.6365 41.2527H82.1529V43.9406H83.6365C84.1848 43.9406 84.6041 43.8292 84.8944 43.5907V43.6066Z",
    fill: "#808284"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0056 45.4038H91.5868L90.9095 46.9625H89.6033L92.6834 40.203H93.9413L97.0376 46.9625H95.6991L95.0056 45.4038ZM94.5863 44.4177L93.2962 41.4594L92.0222 44.4177H94.6025H94.5863Z",
    fill: "#808284"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.649 45.9128V48.4575H107.471V46.9625H101.65V40.203H102.908V45.8968H106.359V40.203H107.617V45.8968H108.633L108.649 45.9128Z",
    fill: "#808284"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.406 40.2186H114.664V45.0218L118.341 40.2186H119.518V46.978H118.26V42.1907L114.583 46.978H113.406V40.2186Z",
    fill: "#808284"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.984 40.2189V46.9784H128.726V45.1016H126.904L125.63 46.9784H124.291L125.759 44.8949C125.291 44.7199 124.92 44.4495 124.662 44.0678C124.404 43.6861 124.275 43.2408 124.275 42.7C124.275 42.1593 124.388 41.7457 124.63 41.364C124.872 40.9823 125.194 40.7119 125.63 40.5052C126.065 40.3143 126.565 40.203 127.146 40.203H130L129.984 40.2189ZM125.984 41.6344C125.71 41.873 125.565 42.2229 125.565 42.6841C125.565 43.1453 125.694 43.4793 125.968 43.7179C126.242 43.9565 126.629 44.0837 127.129 44.0837H128.742V41.3004H127.194C126.678 41.3004 126.275 41.4276 126.001 41.6503L125.984 41.6344Z",
    fill: "#808284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabometInt);
export default __webpack_public_path__ + "static/media/labomet_int.44445f463951c8cf00450a3a6ca84161.svg";
export { ForwardRef as ReactComponent };